import axios from 'axios';
import BaseAPI from './base/base-api';

class InvoiceTrialSupportAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotTrialsAPI';
    controllerName = 'support';
}

export default new InvoiceTrialSupportAPI();